import React, { useState } from 'react';
import { ImageList, ImageListItem, Dialog, DialogTitle, DialogContent, Typography, Box, IconButton, Drawer } from '@mui/material';
import Slide from '@mui/material/Slide';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';

import { useTheme, useMediaQuery } from '@mui/material';
import imageData from '../db/PaintingsList';

const Transition = React.forwardRef(function Transition(
  props, 
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Paintings() {

    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    let columns = 2;
    if (isSm) columns = 3;
    if (isMdUp) columns = 5;

    const handleClick = (item) => {
        setSelectedItem(item);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedItem(null);
    };

    return (
        <>
            <Typography variant="body2" gutterBottom color='white' sx={{ padding: 2 }}>
                Qui ci sono alcuni quadri che apprezzo, sono per la maggior parte dipinti appartenente alla corrente impressionista, 
                mi piace il fatto che venga usato molto il colore per dare risalto a situazioni/emozioni, ci si focalizza molto sull'impatto che l'immagine realizzata dà all'osservatore.
                Dal vivo soprattutto si può apprezzare lo stile forte dato che il colore è usato in abbondanza e spremuto direttamente dal tubetto sulla tela creando così una texture e dei giochi di luce e ombre.
                Vincent Van Gogh è sempre stato il mio pittore preferito, la sua storia è molto toccante e adoro i suoi accostamenti di soggetti e colori. Anche Munch è molto apprezzato per gli stessi motivi, sebbene più "forte" nei colori e nei soggetti;
                mentre Egon Schiele mi piace moltissimo per i soggetti "realistici" in quanto estratti da situazioni intime e soprattutto non idealizzati con corpi e forme perfette/irreali.
                Picasso invece è il pittore che apprezzo meno, mi sta proprio antipatico, ma ho riportato comunque alcune opere. Alcuni quadri sono sconosciuti o hanno nomi d'arte.
            </Typography>
            <ImageList cols={columns} gap={12} sx={{ padding: 2 }}>
                {imageData.map((item) => (
                    <ImageListItem
                        key={item.id}
                        onClick={() => handleClick(item)}
                        sx={{
                            cursor: item.description ? 'pointer' : 'default',
                            position: 'relative',
                            border: item.description ? '1px solid rgba(255, 132, 0, 0.19)' : '2px solid transparent',
                            borderRadius: 0,
                            padding: 1,
                            overflow: 'hidden',
                            '&:hover .info-icon': {
                                opacity: item.description ? 1 : 0,
                            },
                        }}
                    >
                        <img src={item.imageUrl} alt={item.title} loading="lazy" />
                        {item.description && (
                            <InfoIcon
                                className="info-icon"
                                sx={{
                                    position: 'absolute',
                                    bottom: 8,
                                    right: 8,
                                    color: '#ffc107',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    borderRadius: '50%',
                                    padding: '4px',
                                    fontSize: 24,
                                    opacity: 0.9,
                                    transition: 'opacity 0.3s',
                                }}
                            />
                        )}
                        <ImageListItemBar
                            sx={{ color: 'white' }}
                            title={item.title}
                            subtitle={<span>{item.author}</span>}
                            position="below"
                        />
                    </ImageListItem>
                ))}
            </ImageList>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                slots={{
                    transition: Transition,
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: '#111111', // Sfondo della dialog
                        color: 'white',           // Colore del testo di default
                    },
                }}

            >
                {selectedItem && (
                    <>
                        <DialogTitle>
                            {selectedItem.title}
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                                <img
                                    src={selectedItem.imageUrl}
                                    alt={selectedItem.title}
                                    loading="lazy"
                                    style={{
                                        maxWidth: '100%',
                                        height: 'auto',
                                        objectFit: 'contain',
                                        borderRadius: '8px',
                                    }}
                                />
                            </Box>

                            <Typography>{selectedItem.description}</Typography>
                        </DialogContent>
                    </>
                )}
            </Dialog>
        </>

    );
}